export const PRODUCTION_API_URL = 'https://sep.seikosportstech.co.uk';
export const STAGING_API_URL = 'https://staging.sep.seikosportstech.co.uk';
export function environmentForEmail(email) {
  const parts = String(email || '').trim().toLowerCase().split('@');
  return parts.length === 2 && parts[0] && parts[1] === 'test.seikosportstech.com'
    ? 'staging' : 'production';
}
export function apiForEnvironment(environment) {
  return environment === 'staging' ? STAGING_API_URL : PRODUCTION_API_URL;
}
